<template>
  <div class="chat-box">
    <div class="chat-box-body-login">
        <template v-if="showAuthFlow">
          <LoginForm v-if="form_type == 'login'" :redirect="changeFormType" />
          <SignupForm v-if="form_type == 'signup'" :redirect="changeFormType" />
        </template>
        <template v-else-if="showSubsFlow">
          <PaymentChoice v-if="subscriptionDetails?.flow == 'subscribe'" :redirect="changeSubscriptionFlow" />
          <SubscriptionForm v-if="subscriptionDetails?.flow == 'payment'" :subscriptionDetails="subscriptionDetails"
          :redirect="changeSubscriptionFlow"
          />
        </template>
    </div>
  </div>
</template>


<script>
import app from "!raw-loader!@/assets/app.css";
import LoginForm from '@/components/forms/LoginForm_Formacast.vue';
import SignupForm from '@/components/forms/SignupForm_Formacast.vue';
import SubscriptionForm from '@/components/forms/SubscriptionForm_Formacast.vue';
import PaymentChoice from '@/components/forms/PaymentChoice_Formacast.vue';

export default {
  components: {
    LoginForm,
    SignupForm,
    SubscriptionForm,
    PaymentChoice
  },
  data: () => {
    return {
      form_type: "login",
      subscriptionDetails :{
        flow: "subscribe", // "subscribe" or "payment"
        type : null, // "14h" or "42h"
        method : null, // "unique" or "monthly"
      }
    };
  },
  computed: {
    showAuthFlow() {
      return this.$store.state.navigation.showAuthFlow;
    },
    showSubsFlow() {
      return this.$store.state.navigation.showSubsFlow;
    },
  },
  mounted() {
    this.appendStyle();
  },
  methods: {
    appendStyle() {
      const iframe = document.getElementById("cleed-frame");
      const doc = iframe.contentWindow.document

      let app_style = doc.createElement("style");
      app_style.innerHTML = app;
      doc.body.appendChild(app_style);
    },
    changeSubscriptionFlow(flow, type, method) {
      this.subscriptionDetails = {
        flow : flow,
        type : type, 
        method: method
      }

    },
    changeFormType(type) {
      this.form_type = type
    },
    setSubscriptionDetails(type, method){
      this.subscriptionDetails.type = type;
      this.subscriptionDetails.method = method;

    },
    async log_out() {
      await this.$store.commit("LOGOUT");
      this.settingsMenuOn = false;
      this.removeTextArea(this.chat_state);
    },
  }
};
</script>
